import { createSelector } from "reselect";
import { entitiesSelector } from "../App/selector";
import { getListResults } from "@sportnet/redux-list";
import at from "@sportnet/utilities/at";

export const listRequestsSelector = (listName) =>
  createSelector(entitiesSelector, getListResults(listName), (entities, ids) =>
    at(entities.requests, ids || [])
  );
